import React, { useState } from "react"
import tw, { styled } from "twin.macro"
import { useTranslation } from "next-i18next"
import { QuestionDetailFragment } from "../../graphql/generated/graphql"
import { useRouter } from "next/router"

import { ReactComponent as ArrowLeftWhiteSVG } from "../../assets/icons/arrow-white-left-stroke.svg"
import { ReactComponent as ArrowRightWhiteSVG } from "../../assets/icons/arrow-right-no-stroke.svg"
import { Button } from "../../components/formElements/button"

const ArrowLeftWhite = styled(ArrowLeftWhiteSVG)(() => [tw`h-12 w-12`])
const ArrowRightWhite = styled(ArrowRightWhiteSVG)(() => [tw`h-4 w-4`])

interface PreviousNextControlProps {
  nextQuestionId: string | undefined
  previousQuestionId: string | undefined
  currentQuestion: QuestionDetailFragment
  index: number
}

export const PreviousNextControl = ({
  nextQuestionId,
  previousQuestionId,
  currentQuestion,
}: PreviousNextControlProps) => {
  const { t } = useTranslation("question")
  const router = useRouter()
  const [next] = useState(nextQuestionId)
  const [previous] = useState(previousQuestionId)

  const referringProfile = (router.query.profile as string | undefined)?.toLowerCase() ?? ""
  const referringProfileUsername = referringProfile?.length === 0 ? currentQuestion.Artist.username : referringProfile

  const navigatePrevious = async () => {
    await router.push({ pathname: `/q/[id]`, query: { id: previous, profile: referringProfileUsername } })
  }

  const navigateNext = async () => {
    await router.push({ pathname: `/q/[id]`, query: { id: next, profile: referringProfileUsername } })
  }

  return (
    <div data-testid="next-prev-control" tw="flex items-center justify-between py-8 px-4 bg-black rounded-lg h-14">
      {previous ? (
        <div tw="cursor-pointer w-1/2" onClick={navigatePrevious}>
          <ArrowLeftWhite tw="float-left" />
        </div>
      ) : (
        <>&nbsp;</>
      )}
      {next ? (
        <Button
          icon={<ArrowRightWhite />}
          tw="cursor-pointer"
          onClick={navigateNext}
          action={`${t("next_previous_control.next")}`}
        />
      ) : (
        <>&nbsp;</>
      )}
    </div>
  )
}
